export default __webpack_public_path__ + "static/subscription-journey-renewal-472909977cbb33d521a527ddea28930e.svg";